goog.provide('el8.appchart.dialog.implantableDeviceList');

goog.require('el8.ptdata.implantableDevices');
goog.require('el8.template.appchart.dialog.implantableDeviceList');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.ComponentDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.appchart.dialog.addEditImplantableDevice');

el8.appchart.dialog.implantableDeviceList = (function() {

    var that = new el8.uiwidget.ComponentDialog({
        title: 'Implantable Device List',
        height: 500,
        width: 500,
        contentFn: el8.template.appchart.dialog.implantableDeviceList.content
    });

    var component = new el8.uiwidget.Component({
        showFn: function() {
            $('#view-implantable-device-list', that.getContentElt()).addClass('dataLoading');
        },
        dataRenderers: [
            {
                entitySet: el8.ptdata.implantableDevices,
                renderFn: function() {
                    $('#view-implantable-device-list', that.getContentElt()).html(
                        el8.template.appchart.dialog.implantableDeviceList.list({
                            implantableDevices: el8.ptdata.implantableDevices.all().map(function(a) {
                                return a.asSoyMap();
                            })
                        })
                    ).removeClass('dataLoading');
                },
                events: [{eventName: 'all'}]
            }
        ]
    });
    that.setComponent(component);

    var super_show = that.show;
    that.show = function(doLoad) {
        super_show.call(that, doLoad);

        el8.ptdata.implantableDevices.load();
    };

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._bindTriggers();
    };

    that._bindTriggers = function() {
        that.getContentElt().on('click', '.implantable-device-show-trigger',  function() {
            var itemId = $(this).closest('.implantable-device-item').data('id');
            el8.appchart.dialog.addEditImplantableDevice.show(el8.ptdata.implantableDevices.getById(itemId));
            return false;
        });
        that.getContentElt().on('click', '.implantable-device-remove-trigger',  function() {
            var itemId = $(this).closest('.implantable-device-item').data('id');
            var implantableDevice = el8.ptdata.implantableDevices.getById(itemId);
            el8.ptdata.implantableDevices.deleteItem(implantableDevice, that.refresh());
            return false;
        });
        that.getContentElt().on('click', '.implantable-device-add-trigger',  function() {
            el8.appchart.dialog.addEditImplantableDevice.show();
            return false;
        });
    };

    return that;

})();
